import { SecurityOptionType } from '@module/assignment';
import { getDateTime } from '../utils';
import { jsx as _jsx } from "react/jsx-runtime";
export var renderColumns = function renderColumns(_ref) {
  var attendeeSubmissionTranslation = _ref.attendeeSubmissionTranslation;
  return [{
    width: '25%',
    title: attendeeSubmissionTranslation.violateTime,
    dataIndex: 'createAt',
    key: 'createAt',
    render: function render(_, record) {
      return /*#__PURE__*/_jsx("span", {
        children: getDateTime(parseInt(record.createdAt)) || '-'
      });
    }
  }, {
    width: '25%',
    title: attendeeSubmissionTranslation.violateType,
    dataIndex: 'securityOptionId',
    key: 'securityOptionId',
    render: function render(_, record) {
      return /*#__PURE__*/_jsx("span", {
        children: record.securityOptionId === SecurityOptionType.copyPaste ? attendeeSubmissionTranslation.violateCopyPaste : attendeeSubmissionTranslation.violateSwitchTab || '-'
      });
    }
  }];
};